import { motion } from "framer-motion";
import { ArrowRight, PhoneCall } from "lucide-react";

export default function CTASection({ onContact, kakaoChannelUrl }) {
  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="relative bg-black text-white overflow-hidden"
    >
      <div className="absolute inset-0 ds-dot-grid opacity-40" aria-hidden="true" />
      <div className="absolute -bottom-32 -left-32 w-[60vw] h-[60vw] ds-glow opacity-70" aria-hidden="true" />

      <div className="relative max-w-6xl mx-auto px-6 md:px-10 lg:px-16 min-h-[80vh] flex flex-col items-center justify-center text-center py-28 md:py-40">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs font-semibold tracking-[0.25em] uppercase text-white/55"
        >
          Let&apos;s Build Together
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display font-kr mt-8 text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.05] max-w-4xl"
        >
          당신의 아이디어를<br />
          <span className="text-white/55">비즈니스로</span> 연결하세요.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="font-kr mt-8 text-base md:text-lg text-white/65 leading-relaxed max-w-xl"
        >
          기획부터 운영까지, 한 흐름으로 연결되는 디지털 파트너십.<br />
          오늘 시작하는 한 통의 문의가 다음 비즈니스의 출발이 됩니다.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="mt-12 flex flex-col sm:flex-row gap-3 sm:gap-4"
        >
          <button
            data-testid="cta-contact-btn"
            onClick={onContact}
            className="group inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-white text-slate-900 text-[15px] font-semibold hover:bg-slate-100 transition-colors"
          >
            프로젝트 문의하기
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </button>
          <a
            href={kakaoChannelUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="cta-consult-btn"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-white/25 text-white text-[15px] font-semibold hover:bg-white/5 transition-colors"
          >
            <PhoneCall size={16} />
            상담 요청하기
          </a>
        </motion.div>
      </div>
    </section>
  );
}
